// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__xpc6W","alertIcon":"ConfirmModal_alertIcon__27Ah0"};